module.exports = __webpack_public_path__ + "img/none-on.7bbfaeec.svg";